import React, { useState } from 'react'
import { Navigate, Link } from 'react-router-dom'
import { supabase } from '../services/supabaseClient'
import { useAuth } from '../context/AuthContext'

export default function Login() {
  const { session } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  if (session) return <Navigate to="/" replace />

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      const { error } = await supabase.auth.signInWithPassword({ email, password })
      if (error) throw error
    } catch (e) {
      setError(e.message || 'فشل تسجيل الدخول')
    } finally {
      setLoading(false)
    }
  }

  const signInWithGoogle = async () => {
    setError('')
    setLoading(true)
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: window.location.origin,
        },
      })
      if (error) throw error
    } catch (e) {
      setError(e.message || 'تعذر استخدام تسجيل الدخول عبر Google')
      setLoading(false)
    }
  }

  return (
    <div dir="rtl" style={{ maxWidth: 360, margin: '4rem auto', padding: 24, border: '1px solid #ddd', borderRadius: 8 }}>
      <h2 style={{ textAlign: 'center', marginBottom: 16 }}>بوابة الطالب - تسجيل الدخول</h2>
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <input type="email" placeholder="البريد الإلكتروني" value={email} onChange={e => setEmail(e.target.value)} required />
        <input type="password" placeholder="كلمة المرور" value={password} onChange={e => setPassword(e.target.value)} required />
        {error && <div style={{ color: 'red', textAlign: 'right' }}>{error}</div>}
        <button type="submit" disabled={loading}>
          {loading ? 'جاري الدخول...' : 'دخول'}
        </button>
      </form>
      <div style={{ marginTop: 12, textAlign: 'right' }}>
        <Link to="/reset-password">نسيت كلمة المرور؟</Link>
      </div>
      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <span style={{ display: 'block', marginBottom: 8, color: '#6b7280', fontSize: 13 }}>أو</span>
        <button
          type="button"
          onClick={signInWithGoogle}
          disabled={loading}
          style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #e5e7eb', background: '#f9fafb', width: '100%' }}
        >
          الدخول باستخدام Google
        </button>
      </div>
    </div>
  )
}
